import React from 'react';
import {SubTaskCreationSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {SetStatePropsType} from "@baseTypes/base";
import Paper from '@mui/material/Paper';
import {getErrorPropsFromArray} from "@helpers/error";
import SelectTaskTemplateSingleVoyage
	from "@containers/singleVoyage/taskTemplate/select/selectTaskTemplate/SelectTaskTemplateSingleVoyage";
import {useTranslation} from 'react-i18next';
import {ErrorMessage} from "@hooks/validate/types";
import MuiDatePicker from "@ui/datePicker/muiDatePicker/MuiDatePicker";
import {DATE_FORMAT_PLAN_COMPLETION_TIME_TASK_SINGLE_VOYAGE} from "@containers/singleVoyage/tasks/constants/dateFormat";
import {sx} from './sx'
import moment from 'moment'
import InputDebounce from "@ui/inputs/InputDebounce";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import DeleteIcon from '@mui/icons-material/Delete';
import SwitchCustom from "@ui/switchCustom/SwitchCustom";
import {TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";
import SelectMultipleTasksWaypointsByDataSingleVoyage
	from "@containers/singleVoyage/tasks/mutateTask/select/selectWaypoints/SelectMultipleTasksWaypointsByDataSingleVoyage";

interface IProps {
	subtask: SubTaskCreationSingleVoyage,
	index: number,
	setSubtasks: SetStatePropsType<SubTaskCreationSingleVoyage[]>,
	error?: boolean,
	errorMessage?: ErrorMessage,
	waypoints: TaskWayPointSingleVoyage[]
	accountId: string | number
}

const ItemSubtaskSingleVoyage = ({
									 subtask,
									 setSubtasks,
									 error,
									 errorMessage,
									 index,
									 waypoints,
									 accountId,
								 }: IProps) => {
	
	
	const {t} = useTranslation()
	
	
	const handleChange = (
		value: string | number | number[] | null,
		type: 'title' | 'description' | 'taskConfigTemplateId' | 'waypointIds' | 'planCompletionTime'
	) => {
		
		setSubtasks((prev) => {
			return prev?.map((task, i) => {
				if (index === i) {
					return {
						...task,
						[type]: value
					}
				}
				return task
			})
		})
	}
	
	const onDelete = () => {
		setSubtasks((prev) => {
			return prev.filter((task, i) => index !== i)
		})
	}
	const hasPlanCompletionTime = !!subtask.planCompletionTime
	
	const handleChangeHasPlanCompletionTime = (checked: boolean) => {
		const value = checked ? moment().toISOString() : null
		handleChange(value, 'planCompletionTime')
	}
	
	return (
		<Paper
			elevation={3}
			sx={sx.root}
		>
			<IconButtonCustom
				onClick={onDelete}
			>
				<DeleteIcon
					fontSize={'small'}
				/>
			</IconButtonCustom>
			
			<InputDebounce
				initialValue={subtask.title}
				onChange={(value) => handleChange(value, 'title')}
				label={t('base.name')}
				{...getErrorPropsFromArray({errorMessage, error, key: 'title', index})}
			/>
			
			<InputDebounce
				initialValue={subtask.description}
				onChange={(value) => handleChange(value, 'description')}
				label={t('base.description')}
				{...getErrorPropsFromArray({errorMessage, error, key: 'description', index})}
				multiline
				rows={4}
			/>
			
			<SelectTaskTemplateSingleVoyage
				value={subtask.taskConfigTemplateId?.toString() === '0' ? '' : subtask.taskConfigTemplateId.toString()}
				onChange={(value) => handleChange(Number(value), 'taskConfigTemplateId')}
				{...getErrorPropsFromArray({errorMessage, error, key: 'taskConfigTemplateId', index})}
				accountId={accountId}
			/>
			
			
			<SelectMultipleTasksWaypointsByDataSingleVoyage
				value={subtask.waypointIds?.map((id) => id?.toString())}
				onChange={(value) => handleChange(value?.map((id) => Number(id)), 'waypointIds')}
				waypoints={waypoints}
				hasSelectAll
				{...getErrorPropsFromArray({errorMessage, error, key: 'waypointIds', index})}
			/>
			
			<SwitchCustom
				checked={hasPlanCompletionTime}
				onChange={handleChangeHasPlanCompletionTime}
				label={t('base.hasPlanCompletionTime')}
			/>
			
			{hasPlanCompletionTime && <MuiDatePicker
                value={moment(subtask.planCompletionTime,).format(DATE_FORMAT_PLAN_COMPLETION_TIME_TASK_SINGLE_VOYAGE)}
                onChange={(value) => handleChange(moment(value, DATE_FORMAT_PLAN_COMPLETION_TIME_TASK_SINGLE_VOYAGE).toISOString(), 'planCompletionTime')}
                format={DATE_FORMAT_PLAN_COMPLETION_TIME_TASK_SINGLE_VOYAGE}
                showHoursAndMinutes
                fullWidth={false}
                sx={{padding: '0'}}
                label={t('base.planCompletionTime')}
            />}
		
		</Paper>
	);
};

export default ItemSubtaskSingleVoyage;
